import '../styles/list-pages.scss';
import { useTranslate } from 'src/i18n/useTranslate';
import { useSearchParams } from 'react-router-dom';
import { AppLayout, Button, Tabs } from '@cloudscape-design/components';
import { useTutorials } from 'src/components/providers/TutorialsProvider';
import { getHelpContent } from 'src/tutorials/help-content';
import { useWelcomeModal } from 'src/components/providers/WelcomeModalProvider';
import { TABS } from 'src/tutorials/enums';
import { KendraSearchIntegrated } from 'src/components/kendra-search/KendraSearchIntegrated';
import { facetConfiguration } from 'src/components/kendra-search/search/configuration';

const SearchPage = () => {
    const t = useTranslate();
    const [searchParams] = useSearchParams();

    const {
        activeTabId,
        setActiveTabId,
        toolsOpen,
        setToolsOpen,
        helpPanelTopic,
    } = useTutorials();

    const { setWelcomeGruOpen } = useWelcomeModal();

    const searchInput = searchParams.get('q');

    const kendraComponents = KendraSearchIntegrated({
        initialQuery: searchInput || undefined,
        facetConfiguration,
    });

    return (
        <AppLayout
            data-search-app-layout
            headerSelector="#search-filters-navigation"
            navigationHide={false}
            navigationOpen={true}
            navigation={kendraComponents.sidebar}
            maxContentWidth={Number.MAX_VALUE}
            toolsOpen={toolsOpen}
            onToolsChange={({ detail }) => setToolsOpen(detail.open)}
            tools={
                <Tabs
                    activeTabId={activeTabId}
                    onChange={({ detail }) => {
                        setActiveTabId(detail.activeTabId as TABS);
                    }}
                    tabs={[
                        {
                            id: 'help-panel',
                            label: t('help-panel-label', 'Info'),
                            content: getHelpContent(helpPanelTopic),
                        },
                        {
                            id: 'tutorials-panel',
                            label: t('tutorials-panel-label', 'Tutorials'),
                            content: (
                                <div className="flex-row justify-content-center">
                                    <Button
                                        onClick={() => {
                                            setWelcomeGruOpen(true);
                                            setToolsOpen(false);
                                        }}
                                    >
                                        {t(
                                            'launch_gru_tutorial',
                                            'Launch GRU Tutorial'
                                        )}
                                    </Button>
                                </div>
                            ),
                        },
                    ]}
                />
            }
            content={kendraComponents.content}
        />
    );
};

export default SearchPage;
